import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import postRegister from '../libs/register-service'
import { postLogin } from '../libs/login-service'
import { styled } from 'styled-components'
import getClassListDownloadUrl from '../libs/download-service'
import StudentUploader from '../components/StudentUploader'
import { DropDownList, Input, PasswordInput } from '../components/Input'
import { SingleButtonModal } from '../components/shared/Modal'

const Wrapper = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
`
const Img = styled.img`
    width: 50%;
    height: 100%;
    object-fit: cover;
`
const ContentWrapper = styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Title = styled.h1`
    color: #115ff5;
    margin-bottom: 50px;
`

const InternalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`

const NameWrapper = styled.div`
    display: flex;
    gap: 30px;
`

const SubmitButton = styled.button`
    width: fit-content;
    padding: 12px 32px;
    background-color: #1fa474;
    color: #ffffff;
    border: none;
    border-radius: 50px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
    margin-top: 30px;
    margin-bottom: 20px;
    align-self: center;

    &:hover {
        background-color: #188c5f;
    }
`

interface RegisterPageProps {
    setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>
}

export default function Register({ setIsLoggedIn }: RegisterPageProps) {
    const [accountId, setAccountId] = useState(0)
    const [status, setStatus] = useState<'normal' | 'success' | 'fail'>(
        'normal'
    )

    const classListUrl = getClassListDownloadUrl()

    return (
        <Wrapper>
            <Img src="/images/login/login.png" />
            <ContentWrapper>
                <div>
                    <Title>Welcome on board</Title>

                    <RegisterForm
                        setStatus={setStatus}
                        setAccountId={setAccountId}
                        status={status}
                        setIsLoggedIn={setIsLoggedIn}
                    />
                    <div>
                        <a href="login">Back</a>
                    </div>
                </div>
            </ContentWrapper>
        </Wrapper>
    )
}

interface Props {
    setStatus: React.Dispatch<
        React.SetStateAction<'normal' | 'success' | 'fail'>
    >
    setAccountId: React.Dispatch<React.SetStateAction<number>>
    status: string
    setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>
}

function RegisterForm({
    setStatus,
    setAccountId,
    status,
    setIsLoggedIn,
}: Props) {
    const [username, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [firstname, setFirstname] = useState('')
    const [lastname, setLastname] = useState('')
    const [role, setRole] = useState('')
    const navigate = useNavigate()

    useEffect(() => {
        if (status === 'success') {
            const timer = setTimeout(() => {
                navigate('/')
            }, 1500)
            return () => clearTimeout(timer)
        }
    }, [status, navigate])

    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        const body = {
            email: username,
            password: password,
            firstname: firstname,
            lastname: lastname,
            role: role,
        }
        try {
            const { success, accountId } = await postRegister(body)

            if (success) {
                // Auto-login to obtain a valid token
                const loginResult = await postLogin({
                    email: username,
                    password: password,
                })
                if (loginResult.success) {
                    localStorage.setItem(
                        'userId',
                        JSON.stringify(loginResult.userId)
                    )
                    localStorage.setItem('token', loginResult.token)
                    setIsLoggedIn(true)
                    setStatus('success')
                    setAccountId(loginResult.userId)
                } else {
                    // Registration succeeded but auto-login failed; redirect to login
                    setStatus('success')
                    setAccountId(accountId)
                }
            } else {
                setStatus('fail')
            }
        } catch (e) {
            setStatus('fail')
        }
    }
    return (
        <InternalWrapper>
            {status === 'success' && (
                <p> register success, jumping to main page </p>
            )}
            {status === 'fail' && (
                <SingleButtonModal
                    children={'register failed, please try again'}
                    onCancel={() => setStatus('normal')}
                />
            )}
            <form onSubmit={onSubmit}>
                <NameWrapper>
                    <Input title="First Name" onChange={setFirstname} />
                    <Input title="Last Name" onChange={setLastname} />
                </NameWrapper>
                <Input title="Email" onChange={setEmail} />
                <PasswordInput title="Password" onChange={setPassword} />
                <DropDownList title="Role" onChange={setRole} />
                <SubmitButton type="submit">Submit</SubmitButton>
            </form>
        </InternalWrapper>
    )
}
